import React, { createContext, useState, useEffect, useContext } from "react";
import { Auth, Hub } from "aws-amplify";

export const AuthDataContext = createContext(null);

const AuthDataProvider = (props) => {
  function getUser() {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => {});
  }

  const [user, setUser] = useState(null);

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
        case "cognitoHostedUI":
          getUser().then((userData) => setUser(userData));
          break;
        case "signOut":
          setUser(null);
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
        default:
          break;
      }
    });
    getUser().then((userData) => setUser(userData));
  }, []);

  return <AuthDataContext.Provider value={user} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);

export default AuthDataProvider;
